import React from "react";
import { Section } from "components/section";
import { Statistic, Superscript, TextTitle } from "ui/text";
import { useCdpIndustry } from "contexts/cdp-industry-context";
import { Box, SimpleGrid, Text } from "@chakra-ui/react";

export function CdpIndustryLeveragingDataStats() {
  const { industry } = useCdpIndustry();
  return (
    <Section bg={`new.${industry.color}.50`} themeBgColor={`new.${industry.color}.50`}>
      <TextTitle
        size="lg"
        align="center"
        title={`Leveraging your customer data in ${
          industry.abbreviatedName ?? industry.name
        } is more important than ever before`}
        maxW={industry.dataStatsTitleMaxW ?? "725px"}
      />

      <SimpleGrid
        columns={{ base: 1, lg: 3 }}
        alignItems="end"
        gap={{ base: "bigger", md: "biggest", lg: "big" }}
        justifyItems="center"
        mt={{ base: "huge", md: "huge" }}
      >
        {industry.dataStats.map((stat, idx) => {
          return (
            <Box
              key={stat.title}
              w="100%"
              maxW="cardMaxW"
              _notLast={{
                base: { pb: "bigger", borderBottom: "1px", borderColor: "brand.border.light" },
                md: { pb: "biggest" },
                lg: { pb: 0, borderBottom: "none" },
              }}
            >
              <Statistic
                title={
                  <>
                    {stat.title}
                    <Superscript
                      size="md"
                      href={stat.href}
                      text={`${idx + 2}`}
                      top={{ base: "-2rem", lg: "-2.8rem" }}
                      left="0.25rem"
                    />
                  </>
                }
                description={
                  <Text as="span" color="brand.text.light">
                    {stat.description}
                  </Text>
                }
              />
            </Box>
          );
        })}
      </SimpleGrid>
    </Section>
  );
}
